const clear = <T>(array: T[]): void => {

    array.splice(0, array.length);
};

export default clear;